import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const className = sessionStorage.getItem("className");
  const Class11FeesRoute = '/intermediate-accounts-fees-structure-class-xi';
  const Class12FeesRoute = '/intermediate-accounts-fees-structure-class-xii';
  const feesRoute = className === "CLASS_11" ? Class11FeesRoute : className === "CLASS_12" ? Class12FeesRoute : "";
  const Class11DashboardRoute = '/intermediate-accounts-dashboard-class-xi';
  const Class12DashboardRoute = '/intermediate-accounts-dashboard-class-xii';
  const dashboardRoute = className === "CLASS_11" ? Class11DashboardRoute : className === "CLASS_12" ? Class12DashboardRoute : "";
  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">

        <li className={`nav-item ${location.pathname === dashboardRoute ? "active" : ""}`}>
          <a
            className="nav-link back-g"
            href="accounts-dashboard"
            onClick={(e) => {
              e.preventDefault();
              if (dashboardRoute) navigate(dashboardRoute);
            }}
          >
            <i className="icon-grid menu-icon" />
            <span className="menu-title">Class {className === "CLASS_11" ? "XI" : className === "CLASS_12" ? "XII" : ""} Dashboard</span>
          </a>
        </li>

        {/* <li className={`nav-item ${location.pathname === "/intermediate-accounts-reports" ? "active" : ""}`}>
          <a
            className="nav-link back-g"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate("/intermediate-accounts-reports");
            }}
          >
            <i className="fa fa-file menu-icon" />
            <span className="menu-title">
              Class {className === 'CLASS_11' ? 'XI' : className === 'CLASS_12' ? 'XII' : ''} Reports
            </span>
          </a>
        </li> */}

        <li className={`nav-item ${location.pathname === feesRoute ? "active" : ""}`}>
          <a
            className="nav-link back-g"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (feesRoute) navigate(feesRoute);
            }}
          >
            <i className="fa fa-inr menu-icon" />
            <span className="menu-title">
              Class {className === "CLASS_11" ? "XI" : className === "CLASS_12" ? "XII" : ""} Fees Structure
            </span>
          </a>
        </li>


      </ul>
    </nav>
  );
}

export default Sidebar;